<template>
  <div class="register">
    <div class="content">
      <div class="header">
        用户注册
        <span>我已经是会员，<a @click="$loginFrm()">登录</a></span>
      </div>
      <div class="register-form" v-if="!finish">

        <a-form :autoFormCreate="(form)=>{this.form = form}">
          <a-form-item v-show="false" hasFeedback :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" label="昵称" fieldDecoratorId="nickname" :fieldDecoratorOptions="{rules: [{ required: false, message: '请输入用户昵称' }]}">
            <a-input placeholder='请输入用户昵称' size="large" />
          </a-form-item>
          <a-form-item v-show="false" hasFeedback :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" label="公司名称" fieldDecoratorId="company" :fieldDecoratorOptions="{rules: [{ required: false, message: '请输入公司名称' }]}">
            <a-input placeholder='请输入公司名称' size="large" />
          </a-form-item>
          <a-form-item hasFeedback :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" label="手机号" fieldDecoratorId="telphone" :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入手机号' },{ pattern: /^1[345789]\d{9}$/, message: '请输入正确的手机号' }]}">
            <a-input placeholder='请输入手机号' size="large" />
          </a-form-item>
          <a-form-item hasFeedback :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" label="验证码" fieldDecoratorId="verifyCode" :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入验证码' }]}">
            <a-input placeholder='请输入验证码' size="large" style="width:calc(100% - 130px);margin-right:10px;" />
            <a-button :disabled="!!countDown" @click="sendVerify" size="large" style="width:120px;font-size:12px;color:#666;background-color:#f8f8f8;">{{ !countDown && '获取短信验证码' || `${countDown}S` }}</a-button>
          </a-form-item>
          <a-form-item hasFeedback :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" label="登录密码" fieldDecoratorId="password" :fieldDecoratorOptions="{rules: [{ required: true, message: '请您输入密码'},{ message: '密码过短或者过长',min:6,max:20}]}">
            <a-input placeholder='请输入密码' size="large" type="password" />
          </a-form-item>
          <a-form-item hasFeedback :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" label="密码确认" fieldDecoratorId="passwordAgain" :fieldDecoratorOptions="{rules: [{ required: true, message: '请再次输入密码' }, { validator: compareToFirstPassword}]}">
            <a-input placeholder='请再次输入密码' size="large" type="password" />
          </a-form-item>
          <a-form-item hasFeedback :wrapperCol="{ span: 18,offset: 6 }" fieldDecoratorId="yhxy" :fieldDecoratorOptions="{rules: [{ required: true, message: '请阅读并接受用户注册协议' },{ validator: checkYhxy}]}">
            <a-checkbox>阅读并接受<a href="/protocol" target="_blank">用户注册协议</a></a-checkbox>
          </a-form-item>
          <a-form-item hasFeedback :wrapperCol="{ span: 18,offset: 6 }">
            <a-button type='primary' style="width:100%;" size="large" @click="submit">确认，下一步</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="success-tip" v-else>
        <p>
          恭喜您，注册成功！
          <span>
            为确保功能完整体验，请尽快完善个人信息！
          </span>
        </p>
        <p>
          <a-button type='primary' size="large" @click="$router.push({name:'dashboard'})">确认，进入个人中心</a-button>
        </p>
        <p>
          <a @click="$router.back(-1)">跳过，返回注册前页面</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      finish: false,
      form: null,
      countDown: 0
    };
  },
  methods: {
    setCountDown() {
      var that = this;
      var i = setInterval(() => {
        that.countDown -= 1;
        if (that.countDown < 1) {
          clearInterval(i);
        }
      }, 1000);
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("两次输入的密码不一致!");
      } else {
        callback();
      }
    },
    checkYhxy(rule, value, callback){
      if (value===true||value===undefined) {
        callback();
      } else if(value===false) {
        callback("请勾选阅读并接受用户注册协议");
      }
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 昵称非必填，使用电话号码
          values.nickname = values.telphone;
          this.$http
            .post(
              "/zzRegister",
              (this.$route.query.inviteCode &&
                Object.assign(
                  {},
                  { inviteCode: this.$route.query.inviteCode,
                    uni: this.$cookies.get("u")
                   },
                  values
                )) ||
                values
            )
            .then(res => {
              this.$cookies.set("u", "", 0, "/");
              if (!res.error) {
                this.$cookies.set("access-token", res.data.token, "7d", "/");
                this.finish = true;
              } else {
                return this.$message.error(res.errorMsg);
              }
            });
        }
      });
    },
    sendVerify() {
      this.form.validateFields(["telphone"], { force: true }, (err, values) => {
        if (!err) {
          this.$http
            .post("/verifyText", {
              telphone: values.telphone,
              type: 1
            })
            .then(res => {
              this.countDown = 60;
              this.setCountDown();
              if (!!res.error) {
                return this.$message.error(res.errorMsg);
              }
            })
            .catch(e => {
              this.$message.error(e);
              // console.error(e);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.register {
  background-color: #fff;
  .content {
    .success-tip {
      text-align: center;
      p:nth-child(1) {
        margin: 100px auto 150px;
        color: #1ba608;
        font-size: 30px;
        font-weight: bold;
        & > span {
          display: block;
          color: #072c4b;
          font-size: 13px;
          font-weight: normal;
        }
      }
      p:nth-child(2) {
        & /deep/ .ant-btn {
          border-radius: 0;
          width: 400px;
          font-size: 16px;
          font-weight: bold;
        }
      }
      p:nth-child(3) {
        font-size: 13px;
        margin-bottom: 200px;
      }
    }
    .register-form {
      width: 500px;
      margin: auto;

      & /deep/ .ant-input,
      & /deep/ .ant-btn {
        border-radius: 0;
        vertical-align: middle;
      }

      & /deep/ .has-success.has-feedback .ant-form-item-children:after,
      & /deep/ .has-warning.has-feedback .ant-form-item-children:after,
      & /deep/ .has-error.has-feedback .ant-form-item-children:after,
      & /deep/ .is-validating.has-feedback .ant-form-item-children:after,
      & /deep/ .ant-form-item-children-icon  {
        right: auto !important;
      }
    }
    .header {
      padding: 110px 0px 50px;
      width: 1000px;
      margin: auto;
      display: flex;
      vertical-align: middle;
      line-height: 50px;
      font-size: 14px;
      font-weight: bold;
      background: url("~@/assets/img/register-border.png") center 40px no-repeat;

      &::before {
        vertical-align: middle;
        content: " ";
        display: inline-block;
        width: 130px;
        height: 45px;
        @include intop-icon;
        background-position: -45px -315px;
        margin-right: 10px;
      }
      span {
        vertical-align: middle;
        width: 100%;
        text-align: right;
        flex: 1;
        font-size: 13px;
        font-weight: normal;
      }
    }
  }
}
</style>
